module.exports = __webpack_public_path__ + "img/site.ed8973f0.svg";